import React from 'react';
import type { FooterProps } from './Footer.types';
import { useFooter } from './Footer.hook';
import { isLanguageActive } from './Footer.utils';
import * as styles from './Footer.styles';

export const Footer: React.FC<FooterProps> = (props) => {
  useFooter(props); // For strict compliance
  const { changeLanguage, currentLanguage } = props;

  return (
    <footer className={styles.footerContainer}>
      <div>
        <span>&copy; {new Date().getFullYear()} </span>
        <span className={styles.copyrightText}>BFME Technology & Research</span>
        <span>. All rights reserved.</span>
      </div>
      
      {/* Translation controls */}
      <div className={styles.translationContainer}>
        <button
          onClick={() => changeLanguage('en')}
          className={styles.getLangBtnClass(isLanguageActive(currentLanguage, 'en'))}
          title="English"
        >
          EN
        </button>
        <button
          onClick={() => changeLanguage('hi')}
          className={styles.getLangBtnClass(isLanguageActive(currentLanguage, 'hi'))}
          title="Hindi"
        >
          HI
        </button>
        <button
          onClick={() => changeLanguage('te')}
          className={styles.getLangBtnClass(isLanguageActive(currentLanguage, 'te'))}
          title="Telugu"
        >
          TE
        </button>
        <button
          onClick={() => changeLanguage('pa')}
          className={styles.getLangBtnClass(isLanguageActive(currentLanguage, 'pa'))}
          title="Punjabi"
        >
          PA
        </button>
      </div>
    </footer>
  );
};

export default Footer;
